module.exports = "/images/vendor/flag-icon-css/flags/4x3/sa.svg?c36d1991b52ce043a0ae18b32a4da5da";